import axios from 'axios';
import {
  TRANSACTION_TYPE_VALUES,
  PROPERTY_TYPE_VALUES,
} from '../components/actions/constants';

const initialState = {
  zipformTxResp: {},
  zipformTXLoading: false,
  errorMsg: '',
  errorMsgKey: 1,
  authStatus: 'disconnected',
  authStatusErr: false,
  authError: '',
};

export default {
  namespaced: true,
  state: { ...initialState },
  mutations: {
    setZipformTxResponse(state, resp) {
      state.zipformTxResp = resp;
    },
    setZipformTxError(state, errMsg) {
      state.errorMsg = errMsg;
      state.errorMsgKey = Math.floor((Math.random() * 1000) + 1);
    },
    setZipformTxLoading(state, loading) {
      state.zipformTXLoading = loading;
    },
    setZipformAuthStatus(state, status) {
      state.authStatus = status;
    },
    setZipformAuthStatusErr(state, err) {
      state.authStatusErr = err;
    },
    setZipformAuthError(state, err) {
      state.authError = err;
    },
  },

  actions: {
    async setZipformTransaction({ commit }, {
      contact,
      transactionName,
      transactionType,
      propertyType,
      role,
    }) {
      commit('setZipformTxLoading', true);
      const req = {
        transaction: {
          name: transactionName,
          transactionType: TRANSACTION_TYPE_VALUES[transactionType],
          propertyType: PROPERTY_TYPE_VALUES[propertyType],
          role,
          firstName: contact.first_name,
          lastName: contact.last_name,
          phone: contact.mobile_phone,
          email: contact.email,
        },
        contact_id: contact.id,
      };
      try {
        const res = await axios.post(`${process.env.VUE_APP_INTEGRATIONS_ZIPFORM_TX}`, req);
        commit('setZipformTxResponse', res.data);
      } catch (error) {
        commit('setZipformTxError', error.data.message);
      } finally {
        commit('setZipformTxLoading', false);
      }
    },

    async getIntegrationStatus({ commit, rootState, dispatch }, forceUpdate = false) {
      try {
        if (!rootState.integrations.loaded || forceUpdate) {
          await dispatch('integrations/getIntegrations', null, { root: true });
        }
        let integrations = rootState.integrations.integrations;
        const integration = integrations.find(n => n.name === 'ZipForm');

        commit('setZipformAuthStatus', integration.status);
      }
      catch (error) {
        commit('setZipformAuthStatusErr', error);
      }
    },

    async submitZipformAuth({ commit }, { user_name, password }) {
      commit('setZipformTxLoading', true);
      const req = {
        user_name: user_name,
        password: password,
      };

      try {
        await axios.post(`${process.env.VUE_APP_INTEGRATIONS}/zipform/auth`, req);
        commit('setZipformAuthStatus', 'connected');
      } catch (error) {
        commit('setZipformAuthError', error);
      } finally {
        commit('setZipformTxLoading', false);
      }
    },
  },
};
